import { Link } from 'react-router-dom';
import logo from '../images/hardadv-logo.png';
import { useState } from 'react';

export interface INavbarProps {
  currentPage: string;
  onCartClick?: () => void;
  cartItemCount?: number;
}

export const Navbar = (props: INavbarProps) => {
  const { currentPage, onCartClick, cartItemCount } = props;
  const [navMobileActive, setNavMobileActive] = useState<boolean>(false);

  const handleMobileIconClick: any = () => {
    setNavMobileActive(!navMobileActive);
  };

  const cartButton = onCartClick ? (
    <button
      className={`nav__cart-btn ${cartItemCount && cartItemCount > 0 ? 'nav__cart-btn--has-items' : ''}`}
      onClick={onCartClick}
      aria-label={`Koszyk${cartItemCount ? `, ${cartItemCount} produktów` : ''}`}
    >
      <span className="nav__cart-icon">🛒</span>
      {cartItemCount !== undefined && cartItemCount > 0 && (
        <span className="nav__cart-count">{cartItemCount}</span>
      )}
    </button>
  ) : null;

  return (
    <header>
      <nav>
        <div className="content-wrapper">
          <div
            id="nav-mobile-icon"
            className={`nav-mobile__icon ${navMobileActive && 'nav-mobile__icon--active'}`}
            onClick={() => handleMobileIconClick()}
          >
            &#9776;
          </div>
          <Link to="/">
            <img src={logo} title="Strona główna" className="nav__logo" alt="#HardAdv logo" />
          </Link>
          <div className="nav-desktop">
            {/* <Link to="/o-wydarzeniu" className={`nav__item ${currentPage === 'o-wydarzeniu' && 'nav__item--active'}`}>O wydarzeniu</Link> */}
            <Link to="/galeria" className={`nav__item ${currentPage === 'galeria' && 'nav__item--active'}`}>GALERIA IMPREZ</Link>
            {/* <Link to="/rozklad-jazdy" className={`nav__item ${currentPage === 'rozklad-jazdy' && 'nav__item--active'}`}>Rozkład jazdy</Link> */}
            <Link to="/partnerzy" className={`nav__item ${currentPage === 'zostan-sponsorem' && 'nav__item--active'}`}>PARTNERZY HARD ADV</Link>
            <Link to="/rejestracja" className={`nav__item ${currentPage === 'rejestracja' && 'nav__item--active'}`}>WYPRAWY HARDADV</Link>
            <Link to="/hard-adv-store" className={`nav__item ${currentPage === 'hard-adv-store' && 'nav__item--active'}`}>SKLEP HARDADV</Link>
            <Link to="/kontakt" className={`nav__item ${currentPage === 'kontakt' && 'nav__item--active'}`}>Kontakt</Link>
            {cartButton}
          </div>

          <div className={`nav-mobile ${navMobileActive && 'nav-mobile--active'}`}>
            {/* <Link to="/o-wydarzeniu" className={`nav__item ${currentPage === 'o-wydarzeniu' && 'nav__item--active'}`}>O wydarzeniu</Link>*/}
            <Link to="/galeria" className={`nav__item ${currentPage === 'galeria' && 'nav__item--active'}`}>GALERIA IMPREZ</Link>
            {/* <Link to="/rozklad-jazdy" className={`nav__item ${currentPage === 'rozklad-jazdy' && 'nav__item--active'}`}>Rozkład jazdy</Link> */}
            <Link to="/partnerzy" className={`nav__item ${currentPage === 'zostan-sponsorem' && 'nav__item--active'}`}>PARTNERZY HARD ADV</Link>
            <Link to="/rejestracja" className={`nav__item ${currentPage === 'rejestracja' && 'nav__item--active'}`}>WYPRAWY HARDADV</Link>
            <Link to="/hard-adv-store" className={`nav__item ${currentPage === 'hard-adv-store' && 'nav__item--active'}`}>SKLEP HARDADV</Link>
            <Link to="/kontakt" className={`nav__item ${currentPage === 'kontakt' && 'nav__item--active'}`}>Kontakt</Link>
            {cartButton}
          </div>
        </div>
      </nav>
    </header>
  );
};
